import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { Checkbox } from 'ui-components/components/checkbox';

import style from './print-modal-content.module.less';
import { excludeDefaultOption, documentTypeToRealProps } from './constants';
import { DocumentTypePropType } from '../../../../prop-types/document-type';

export const RememberPrintSetting = ({ documentType = '', rememberPrintSettings = false, setRememberPrintSettings }) => {
  if (excludeDefaultOption.includes(documentType)) {
    return null;
  }
  return (
    <div>
      <Checkbox
        checked={rememberPrintSettings}
        className={style['remember-checkbox']}
        label={
          <FormattedMessage
            {...documentTypeToRealProps[documentType].getPrintDefaultMessageDescriptor()}
            values={{
              b: (chunks) => <b>{chunks}</b>,
            }}
          />
        }
        onChange={(isChecked) => setRememberPrintSettings(isChecked)}
      />
    </div>
  );
};

RememberPrintSetting.propTypes = {
  documentType: DocumentTypePropType,
  rememberPrintSettings: PropTypes.bool,
  setRememberPrintSettings: PropTypes.func.isRequired,
};
